import React from 'react';
import { AlertDialog as ChakraAlertDialog, AlertDialogProps as ChakraAlertDialogProps } from '@chakra-ui/react';

export function AlertDialog(props: ChakraAlertDialogProps) {
  return <ChakraAlertDialog {...props} />;
}
